import { useState } from 'react';

const faqs = [
  {
    q: '「故纸瓜档」主要聊什么内容？',
    a: '我们专注娱乐圈陈年旧瓜、历史爆料与八卦爆料的考古重读。把尘封多年的旧闻翻出来，用今天的视角重新解读当年真相，还原被时间冲淡的细节与反转。',
  },
  {
    q: '为什么把八卦叫作「考古重读」？',
    a: '很多旧瓜的原始素材散落在旧报道、旧访谈和老照片里。我们像考古一样逐帧回看这些原始档案，重读当年的语境，往往能发现当年被忽略的线索和后来被证明的判断。',
  },
  {
    q: '栏目里的「当年真相」如何保证客观？',
    a: '我们坚持从最早的公开来源出发，优先追溯传闻的第一现场，并明确区分「公开事实」与「网络传言」。无法证实的部分会明确标注，绝不用推测冒充事实。',
  },
  {
    q: '读者可以参与投稿或补充资料吗？',
    a: '当然可以。欢迎通过页面底部「投稿爆料」入口提交你掌握的旧报道、老照片或一手见闻，我们会核验来源后再纳入档案。',
  },
  {
    q: '「旧事重提」和「翻黑历史」是一回事吗？',
    a: '不是。我们重提旧事的目的，是用今天更完整的信息补全当年的叙事，还原来龙去脉。我们不做断章取义的攻击，也尽量避免伤害当事人。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section className="bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="text-sm font-medium tracking-wide text-primary-700">FAQ</p>
            <h2 className="mt-1 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              读者常问 · 旧瓜答疑
            </h2>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              关于故纸瓜档的定位、考据方法与投稿方式，这些问题的答案都列在这里。若有更多疑问，欢迎直接投稿告诉我们。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-question-mark"></i>
              </span>
              <p className="text-sm leading-6 text-foreground-700">对某条旧瓜有独到资料？期待你的来信与补充。</p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                      open ? 'border-accent-300' : 'border-background-200'
                    }`}
                  >
                    <button
                      onClick={() => setOpenIdx(open ? null : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-display text-base font-bold text-foreground-900">{f.q}</span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-transform ${open ? 'rotate-45 text-accent-600' : 'text-foreground-500'}`}>
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {open && (
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}